import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "../TitleHeader.vue";
import ResourceCards from "../resources/ResourceCards.vue";
import UserBookingTable from "../tables/UserBookingsTable.vue";
import AlertCard from "@/components/AlertCard.vue";
import ExternalLink from "@/components/ExternalLink.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'InitiateDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());
const traning_survey_url = ref("");
const showSurveyBanner = ref(false);

const isLoadingResources = ref(true);
const resources = ref([] as any[]);

async function fetchResources() {
  isLoadingResources.value = true;
  resources.value = (
    await api.resources.listResources({
      role: userHasRole(user.value.roles, ["certified-facilitator"]) ? "certified-facilitator" : "certified-facilitator-trainee",
      page: 1,
    })
  ).data.resources;
  isLoadingResources.value = false;
}

async function getSurveys() {
  console.log("getSurveys");  
  const response = await api.surveys.getCourseSurveyLinks();
  if (response.data.outstanding_surveys.length > 0) {
    traning_survey_url.value = response.data.training_survery_url;
    showSurveyBanner.value = true;
  }
}

;(
  ([__temp,__restore] = _withAsyncContext(() => getSurveys())),
  await __temp,
  __restore()
);
fetchResources();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showSurveyBanner.value)
      ? (_openBlock(), _createBlock(AlertCard, {
          key: 0,
          type: "warning",
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("facilitator-banner")), 1),
              _createVNode(ExternalLink, {
                type: "button",
                href: traning_survey_url.value,
                label: _ctx.$t('complete-survey')
              }, null, 8, ["href", "label"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createVNode(UserBookingTable, { limit: 5 }),
    (!isLoadingResources.value)
      ? (_openBlock(), _createBlock(ResourceCards, {
          key: 1,
          role: _unref(user).roles[0].name,
          resources: resources.value.splice(0, 3)
        }, null, 8, ["role", "resources"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})